import { gql } from '@/__generated__/gql';

export const INVESTOR_DETAILS_SUMMARY_TAB_HOUSEHOLD_SUMMARY_QUERY = gql(`
query InvestorDetailsSummaryTabHouseholdSummary($data: InvestorHouseholdSummaryInput!) {
  investorHouseholdSummary(data: $data) {
    total
    page
    perPage
    limit
    offset
    lastPage
    data {
      primaryLegalEntityId
      name
      totalEntityValue
      privateCapitalPercentage
      currentNAV
      unfundedCommitment
      targetOverCommitmentRatio
      capacity
      ignoreAllocationTargets
      groupedLegalEntitiesSummary {
        id
        name
        currentNAV
        totalEntityValue
        unfundedCommitment
      }
      ignoreAllocationTargets
    }
    totals {
      entityValueTotal
      currentNAVTotal
      unfundedCommitmentTotal
      capacityTotal
      ignoreAllocationTargets
    }
  }
}
`);
